'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'

const RandomBanner = ({ bannerKey = 'about_page' }) => {
    const [slide, setSlide] = useState(null)
    const [loaded, setLoaded] = useState(false)
    const [imagesLoaded, setImagesLoaded] = useState(0)

    const totalImages = slide ? (slide.leftImage ? 1 : 0) + (slide.rightImage ? 1 : 0) : 0

    useEffect(() => {
        fetch(`/api/banner/random-slide?key=${bannerKey}`)
            .then(res => res.ok ? res.json() : null)
            .then(data => setSlide(data))
            .catch(() => {})
    }, [bannerKey])

    // Mark as loaded when all images are ready
    useEffect(() => {
        if (totalImages > 0 && imagesLoaded >= totalImages) {
            setLoaded(true)
        }
    }, [imagesLoaded, totalImages])

    const handleImageLoad = () => {
        setImagesLoaded(prev => prev + 1)
    }

    return (
        <div className="max-w-[1800px] mb-4 w-full relative">
            {/* Placeholder - fades out when images load */}
            <div
                className={`flex transition-opacity duration-500 ${loaded ? 'opacity-0 absolute inset-0' : 'opacity-100'}`}
                aria-hidden={loaded}
            >
                <div className="w-3/5 bg-gray-5 aspect-[1500/450]" />
                <div className="w-2/5 bg-gray-5 aspect-[1000/450]" />
            </div>

            {/* Actual images - fade in when loaded */}
            {slide && (
                <div className={`flex transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0 absolute inset-0'}`}>
                    {slide.leftImage && (
                        <div className="w-3/5">
                            <Image
                                src={slide.leftImage.src}
                                alt={slide.leftImage.alt}
                                width={slide.leftImage.width || 1500}
                                height={slide.leftImage.height || 450}
                                className="w-full h-auto"
                                onLoad={handleImageLoad}
                                priority
                            />
                        </div>
                    )}
                    {slide.rightImage && (
                        <div className="w-2/5">
                            <Image
                                src={slide.rightImage.src}
                                alt={slide.rightImage.alt}
                                width={slide.rightImage.width || 1000}
                                height={slide.rightImage.height || 450}
                                className="w-full h-auto"
                                onLoad={handleImageLoad}
                                priority
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default RandomBanner
